import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from "@react-navigation/native";
import * as React from "react";
import { View } from "react-native";
export default function Background(_param) {
    var style = _param.style, rest = _object_without_properties(_param, [
        "style"
    ]);
    var colors = useTheme().colors;
    return /*#__PURE__*/ _jsx(View, _object_spread_props(_object_spread({}, rest), {
        style: [
            {
                flex: 1,
                backgroundColor: colors.background
            },
            style
        ]
    }));
}
